module.exports = __webpack_public_path__ + "img/img_bed_app_popup_en.edfb8584.png";